const initialState = {
  m3uData: "",
  M3UParseData: "",
  M3UCategory: [],
};

const m3uReducer = (state = initialState, action) => {
  switch (action.type) {
    case "M3U_PLAYLIST_URL":
      return {
        ...state,
        m3uData: action.payload,
      };
    case "M3U_PARSE_DATA":
      return {
        ...state,
        M3UParseData: action.payload,
      };
    case "M3U_PLAYLIST_CATEGORY":
      return {
        ...state,
        M3UCategory: action.payload,
      };
    // M3U_PLAYLIST
    default:
      return state;
  }
};

export default m3uReducer;
